import { TDataSource } from './dataSource';
import { TEnumerationType } from './type';

export type TConsolePlatformKey =
  | 'playstation'
  | 'xbox'
  | 'nintendo'
  | 'playStation4'
  | 'playStation5'
  | 'xboxOne'
  | 'xboxSeriesxs'
  | 'nintendoSwitch'
  | 'nintendoWiiU'
  | 'wiiU'
  | 'ps4'
  | 'ps5'
  | 'switch'
  | 'playstationStoreRank'
  | 'xboxStoreRank'
  | 'nintendoStoreRank';
export type TConsolePlatformValue =
  | 'PlayStation'
  | 'Xbox'
  | 'Nintendo'
  | 'PlayStation 4'
  | 'PlayStation 5'
  | 'Xbox Series X|S'
  | 'Xbox One'
  | 'Nintendo Switch'
  | 'Nintendo Wii U'
  | 'WII U'
  | 'PS4'
  | 'PS5'
  | 'Switch'
  | 'play_station'
  | 'xbox'
  | 'nintendo';
export type TMobilePlatformKey =
  | 'ios'
  | 'android'
  | 'appStore'
  | 'googlePlay'
  | 'specialAppStore'
  | 'specialGooglePlay';
export type TMobilePlatformValue =
  | 'ios'
  | 'Android'
  | 'app_store'
  | 'google_play'
  | 'appstore'
  | 'googleplay';
export type TGamePlatformKey = 'steam' | 'epic';
export type TGamePlatformValue = 'epic' | 'steam';

export interface IPlatformProp {
  // 自身的key
  key: TConsolePlatformKey | TMobilePlatformKey | TGamePlatformKey;
  // 显示的文本
  label?: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: TConsolePlatformValue | TMobilePlatformValue | TGamePlatformValue;
  // 展示在什么平台
  platform?: string;
  // 属于哪个数据源
  source?: TDataSource;
  // 枚举类型
  enumType: TEnumerationType;
}

export type IConsolePlatform = Record<TConsolePlatformKey, IPlatformProp>;
export type IMobilePlatform = Record<TMobilePlatformKey, IPlatformProp>;
export type IGamePlatform = Record<TGamePlatformKey, IPlatformProp>;

export const CONSOLE_PLATFORM: IConsolePlatform = {
  playstation: {
    label: 'PlayStation',
    labelKey: 'dbi_store_rank_console_playstation',
    value: 'PlayStation',
    source: 'mscience',
    platform: 'console',
    key: 'playstation',
    enumType: 'platformPC',
  },
  playstationStoreRank: {
    label: 'Playstation',
    labelKey: '',
    value: 'play_station',
    source: '',
    platform: 'console',
    key: 'playstationStoreRank',
    enumType: 'platformPC',
  },
  xbox: {
    label: 'Xbox',
    labelKey: 'dbi_store_rank_console_xbox',
    value: 'Xbox',
    source: 'mscience',
    platform: 'console',
    key: 'xbox',
    enumType: 'platformPC',
  },
  xboxStoreRank: {
    label: 'Xbox',
    labelKey: '',
    value: 'xbox',
    source: '',
    platform: 'console',
    key: 'xboxStoreRank',
    enumType: 'platformPC',
  },
  nintendo: {
    label: 'Nintendo',
    labelKey: 'dbi_store_rank_console_nintendo',
    value: 'Nintendo',
    source: 'mscience',
    platform: 'console',
    key: 'nintendo',
    enumType: 'platformPC',
  },
  nintendoStoreRank: {
    label: 'Nintendo',
    labelKey: '',
    value: 'nintendo',
    source: '',
    platform: 'console',
    key: 'nintendoStoreRank',
    enumType: 'platformPC',
  },
  playStation4: {
    label: 'PlayStation 4',
    value: 'PlayStation 4',
    labelKey: '',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'xbox',
    enumType: 'platformPC',
  },
  playStation5: {
    label: 'PlayStation 5',
    labelKey: '',
    value: 'PlayStation 5',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'nintendo',
    enumType: 'platformPC',
  },
  xboxOne: {
    label: 'Xbox One',
    labelKey: '',
    value: 'Xbox One',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'xbox',
    enumType: 'platformPC',
  },
  xboxSeriesxs: {
    label: 'Xbox Series X|S',
    labelKey: '',
    value: 'Xbox Series X|S',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'nintendo',
    enumType: 'platformPC',
  },
  nintendoSwitch: {
    label: 'Nintendo Switch',
    labelKey: '',
    value: 'Nintendo Switch',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoSwitch',
    enumType: 'platformPC',
  },
  nintendoWiiU: {
    label: 'Nintendo Wii U',
    labelKey: '',
    value: 'WII U',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoWiiU',
    enumType: 'platformPC',
  },
  wiiU: {
    label: 'Nintendo Wii U',
    labelKey: '',
    value: 'WII U',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoWiiU',
    enumType: 'platformPC',
  },
  ps5: {
    label: 'PS5',
    value: 'PS5',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'ps5',
    enumType: 'platformPC',
  },
  ps4: {
    label: 'PS4',
    value: 'PS4',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'ps4',
    enumType: 'platformPC',
  },
  switch: {
    label: 'Switch',
    value: 'Switch',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'switch',
    enumType: 'platformPC',
  },
};
export const CONSOLE_PLATFORM_ICON: any = {
  pc: {
    label: 'PC',
    labelKey: 'dbi_store_rank_console_pc',
    value: 'PC',
    icon: 'pc',
    source: 'mscience',
    platform: 'console',
    key: 'pc',
    enumType: 'platformPCIcon',
  },
  pcSteam: {
    label: 'PC(Steam)',
    labelKey: 'dbi_store_rank_console_pc_steam',
    value: 'PC',
    icon: 'pc',
    source: 'mscience',
    platform: 'console',
    key: 'pcSteam',
    enumType: 'platformPCIcon',
  },
  playstation: {
    label: 'PlayStation',
    labelKey: 'dbi_store_rank_console_playstation',
    value: 'PlayStation',
    icon: 'playstation',
    source: 'mscience',
    platform: 'console',
    key: 'playstation',
    enumType: 'platformPCIcon',
  },
  playstationStoreRank: {
    label: 'Playstation',
    labelKey: '',
    value: 'play_station',
    source: '',
    icon: 'playstationStoreRank',
    platform: 'console',
    key: 'playstationStoreRank',
    enumType: 'platformPCIcon',
  },
  xbox: {
    label: 'Xbox',
    labelKey: 'dbi_store_rank_console_xbox',
    value: 'Xbox',
    source: 'mscience',
    icon: 'xbox',
    platform: 'console',
    key: 'xbox',
    enumType: 'platformPCIcon',
  },
  xboxStoreRank: {
    label: 'Xbox',
    labelKey: '',
    value: 'xbox',
    source: '',
    icon: 'xboxStoreRank',
    platform: 'console',
    key: 'xboxStoreRank',
    enumType: 'platformPCIcon',
  },
  nintendo: {
    label: 'Nintendo',
    labelKey: 'dbi_store_rank_console_nintendo',
    value: 'Nintendo',
    source: 'mscience',
    platform: 'console',
    key: 'nintendo',
    icon: 'nintendo',
    enumType: 'platformPCIcon',
  },
  nintendoStoreRank: {
    label: 'Nintendo',
    labelKey: '',
    value: 'nintendo',
    source: '',
    platform: 'console',
    key: 'nintendoStoreRank',
    icon: 'nintendoStoreRank',
    enumType: 'platformPCIcon',
  },
  playStation4: {
    label: 'PlayStation 4',
    value: 'PlayStation 4',
    labelKey: '',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'xbox',
    icon: 'playStation',
    enumType: 'platformPCIcon',
  },
  playStation5: {
    label: 'PlayStation 5',
    labelKey: '',
    value: 'PlayStation 5',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'nintendo',
    icon: 'playStation',
    enumType: 'platformPCIcon',
  },
  xboxOne: {
    label: 'Xbox One',
    labelKey: '',
    value: 'Xbox One',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'xbox',
    icon: 'xbox',
    enumType: 'platformPCIcon',
  },
  xboxSeriesxs: {
    label: 'Xbox Series X|S',
    labelKey: '',
    value: 'Xbox Series X|S',
    source: 'npd,newzoo,gsd',
    platform: 'console',
    key: 'nintendo',
    icon: 'xbox',
    enumType: 'platformPCIcon',
  },
  nintendoSwitch: {
    label: 'Nintendo Switch',
    labelKey: '',
    value: 'Nintendo Switch',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoSwitch',
    icon: 'nintendo',
    enumType: 'platformPCIcon',
  },
  nintendoWiiU: {
    label: 'Nintendo Wii U',
    labelKey: '',
    value: 'WII U',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoWiiU',
    icon: 'nintendo',
    enumType: 'platformPCIcon',
  },
  wiiU: {
    label: 'Nintendo Wii U',
    labelKey: '',
    value: 'WII U',
    source: 'npd,gsd',
    platform: 'console',
    key: 'nintendoWiiU',
    icon: 'nintendoWiiU',
    enumType: 'platformPCIcon',
  },
  ps5: {
    label: 'PS5',
    value: 'PS5',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'ps5',
    enumType: 'platformPCIcon',
  },
  ps4: {
    label: 'PS4',
    value: 'PS4',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'ps4',
    enumType: 'platformPCIcon',
  },
  switch: {
    label: 'Switch',
    value: 'Switch',
    source: 'npd,famitsu',
    platform: 'console',
    key: 'switch',
    enumType: 'platformPCIcon',
  },
};

export const MOBILE_PLATFORM: IMobilePlatform = {
  ios: {
    labelKey: 'dbi_benchmark_ios',
    value: 'ios',
    key: 'ios',
    enumType: 'platformMobile',
  },
  android: {
    labelKey: 'dbi_benchmark_android',
    value: 'Android',
    key: 'android',
    enumType: 'platformMobile',
  },
  appStore: {
    label: 'App Store',
    labelKey: 'dbi_benchmark_ios',
    value: 'app_store',
    key: 'appStore',
    enumType: 'platformMobile',
  },
  googlePlay: {
    label: 'Google Play',
    labelKey: 'dbi_benchmark_android',
    value: 'google_play',
    key: 'googlePlay',
    enumType: 'platformMobile',
  },
  specialAppStore: {
    label: 'iOS',
    value: 'appstore',
    key: 'specialAppStore',
    enumType: 'platformMobile',
  },
  specialGooglePlay: {
    label: 'Google Play',
    value: 'googleplay',
    key: 'specialGooglePlay',
    enumType: 'platformMobile',
  },
};

export const GAME_PLATFORM: IGamePlatform = {
  steam: {
    label: 'Steam',
    value: 'steam',
    key: 'steamLowercase',
    enumType: 'platformGame',
  },
  epic: {
    label: 'Epic',
    value: 'epic',
    key: 'steam',
    enumType: 'platformGame',
  },
};
